import React, { Component } from 'react';
import NavMenu from './NavMenu';

export default class Layout extends Component {
    constructor() {
        super();
        this.state = {
            className: '',
            timerId: localStorage.getItem("authTimerId")
        };
    }

    componentDidMount() {
        var scope = this;
        fetch('api/Event/ClassName', {
            method: 'GET',
            headers: {
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ "className": result.className });
                }).catch((err) => console.log(err));
            }
        });

        if (this.state.timerId) {
            window.clearInterval(this.state.timerId);
        }

        let timerId = window.setInterval(() => {
            var token = localStorage.getItem("token");
            if (token) {
                fetch('api/Identity/Ping', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                }).then(function (res) {
                    if (res.status === 401) {
                        document.location.reload();
                    }
                });
            }
        }, 300000);

        localStorage.setItem("authTimerId", timerId);
    }

    render() {
        return (<div className={this.state.className}>
            <NavMenu/>
            <div className="main-container">
                {this.props.children}
            </div>
        </div>);
    }
}

